import { useEffect } from 'react'
import { getToken } from '@/lib/auth'
import { useAppStore } from '@/store'

const BASE_URL = '/api'

export function useEventStream() {
  const addActivity = useAppStore((s) => s.addActivity)

  useEffect(() => {
    const token = getToken()
    if (!token) return

    const url = `${BASE_URL}/dashboard/stream?token=${encodeURIComponent(token)}`
    const es = new EventSource(url)

    es.addEventListener('audit', (e) => {
      try {
        const data = JSON.parse(e.data)
        const events = data.events || []
        for (const evt of events.slice(0, 3)) {
          addActivity({
            id: `sse_${evt.id || Date.now()}`,
            type: evt.event_type?.includes('DEPLOY') ? 'deploy' : evt.blocked ? 'alert' : 'audit',
            title: evt.event_type || 'Security Event',
            description: typeof evt.details === 'string' ? evt.details : JSON.stringify(evt.details).slice(0, 120),
            timestamp: new Date(evt.created_at || Date.now()),
            severity: evt.blocked ? 'error' : 'info',
          })
        }
      } catch { /* ignore parse errors */ }
    })

    es.addEventListener('approvals', (e) => {
      try {
        const data = JSON.parse(e.data)
        if (data.pending_count > 0) {
          addActivity({
            id: `sse_approval_${Date.now()}`,
            type: 'approval',
            title: `${data.pending_count} pending approval(s)`,
            description: 'Approval queue updated via live feed',
            timestamp: new Date(),
            severity: 'warning',
          })
        }
      } catch { /* ignore */ }
    })

    es.onerror = () => {
      es.close()
    }

    return () => {
      es.close()
    }
  }, [addActivity])
}
